export let Status = [
  {
    key: "EM_ABERTO",
    name: "Em Aberto",
  },
  {
    key: "FINALIZADO",
    name: "Finalizado",
  },
];

export let StatusSolicitation = [
  {
    key: "EM_ABERTO",
    name: "Em Aberto",
  },
  {
    key: "FINALIZADO",
    name: "Finalizado",
  },
];

export function convertStatus(situacao) {
  const value = Status.find((type) => type.key == situacao);
  return value.name;
}
